export default {
    MESSAGE_DURATION: 1000
}



// WEBPACK FOOTER //
// ./src/config/settings.js